<template>
  <div>
    <vs-prompt
      title="Select product to add"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add product"
      :is-valid="validForm"
      class="add-stock-transfer-product-popup"
    >
      <Loading v-if="isLoading" />
      <div v-else class="data-list-container data-list-list-view">
        <vs-table
          v-if="filteredProducts"
          ref="table"
          class="mt-8"
          pagination
          search
          maxItems="6"
          v-model="selectedProduct"
          :data="filteredProducts"
          noDataText="No data"
        >
          <template slot="thead">
            <vs-th sort-key="number">number</vs-th>
            <vs-th sort-key="stockProduct.name">Name</vs-th>
            <vs-th>Category</vs-th>
            <!-- <vs-th>Vendor</vs-th> -->
            <vs-th sort-key="unitPrice">Unit price</vs-th>
            <vs-th sort-key="fromVenueMainStorageStockAmount">From venue stock</vs-th>
            <vs-th sort-key="toVenueMainStorageStockAmount">To venue stock</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <div class="product-name font-medium truncate flex flex-row items-center">
                    <img width="40" :src="ProductIcon" />
                    <p class="ml-4">{{ tr.stockProduct.number }}</p>
                  </div>
                </vs-td>
                <vs-td :data="tr.stockProduct.name">
                  <div v-if="tr.stockProduct.name">
                    {{ tr.stockProduct.name }}
                  </div>
                  <div v-else>
                    <vs-chip> No name </vs-chip>
                  </div>
                </vs-td>
                <vs-td>
                  <div v-if="tr.productCategory">
                    {{ tr.productCategory.name }}
                  </div>
                  <div v-else>
                    <vs-chip>No category</vs-chip>
                  </div>
                </vs-td>
                <!-- <vs-td>
                  <div v-if="tr.vendor">
                    {{ tr.vendor.name }}
                  </div>
                  <div v-else>
                    <vs-chip>No vendor</vs-chip>
                  </div>
                </vs-td> -->
                <vs-td>
                  {{ tr.unitPrice }}
                </vs-td>
                <vs-td>
                  <div>
                    {{ tr.fromVenueMainStorageStockAmount }}
                  </div>
                </vs-td>
                <vs-td>
                  <div>
                    {{ tr.toVenueMainStorageStockAmount }}
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProductIcon from "@/assets/images/product-icon.png";
export default {
  data() {
    return {
      moment,
      ProductIcon,

      prompt: false,
      selectedProduct: null,

      eligibleProductsInfo: null,
    };
  },
  props: {
    existingProducts: {
      type: Array,
      default: () => [],
    },
    isReceiving: {
      type: Boolean,
      default: false,
    },
    activeVenueId: {
      type: String,
      default: "",
    },
    otherVenueId: {
      type: String,
      default: "",
    }
  },
  computed: {
    ...mapGetters({
      stockProducts: "stockProducts/stockProducts",
      isLoading: "bookingProducts/isLoading",
    }),
    validForm() {
      return this.selectedProduct != null;
    },

    // Filter out products already in the booking form
    filteredProducts() {
      console.log("Existing products", this.existingProducts);
      console.log("Eligible products", this.eligibleProducts);

      if (!this.eligibleProductsInfo) {
        return [];
      }

      return this.eligibleProductsInfo.productsEligibleForTransfer
        .filter(productInfo => !this.existingProducts.find(existingProduct => existingProduct.id === productInfo.stockProduct.stockProductId.id))
    }
  },
  methods: {
    async show() {
      // dispatch eligible products
      const fromVenueId = this.isReceiving ? this.otherVenueId : this.activeVenueId; 
      const toVenueId = this.isReceiving ? this.activeVenueId : this.otherVenueId;

      try {

      if (!fromVenueId || !toVenueId) {
        throw new Error("Missing venue id");
      }

      this.eligibleProductsInfo = await this.$store.dispatch("stockTransfers/getEligibleProducts", {
        fromVenueId,
        toVenueId,
      });

      this.prompt = true;
      } catch (err) {
        let message = err;
        if (err.error) message = err.error;

        this.$vs.notify({
          title: "Could not load stock products",
          text: message,
          color: "danger",
        });
      }
    },
    async accept() {
      const productDto = {
        id: this.selectedProduct.stockProduct.stockProductId.id,
        name: this.selectedProduct.stockProduct.name,
        maxAmount: this.selectedProduct.fromVenueMainStorageStockAmount,
      }

      this.$emit("productSelected", productDto);
    },
  },
};
</script>

<style lang="scss">
.add-stock-transfer-product-popup {
  z-index: 52011;

  .vs-dialog {
    max-width: 900px;

    .vs-dialog-text {
      background-color: #f8f8f8;
    }

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
